import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Table from '../../components/tables/Table';
import ActionBar from '../../components/admin/helpers/ActionBar';
import { HEADERS, SMALL_COLUMNS, LARGE_COLUMNS } from '../../constants/admin/tables';
import { getText } from '../../constants/admin/texts';
import { select, newAction, openAction, initTable, changeSort, search, updateFilter } from '../../actions/admin/tables';
import * as selectors from '../../selectors/admin/tables';
import { contextSubjectSelector } from '../../selectors/admin/context';
import { ifPermission, PERMISSIONS } from '../../constants/authentication/permissions';
import { currentUserSelector, preferencesSelector } from '../../selectors/authentication';
import BaseAdminTable from './BaseAdminTable';

class AdminTable extends BaseAdminTable {
    render() {
        const { AdvancedSearchForm } = this.props;
        const deletePermission = PERMISSIONS[`${this.props.model.toUpperCase()}S_DELETE`];
        return (
            <div className="ckp-admin-table">
                <ActionBar
                    title={this.props.title}
                    skipDeleteConfirm={this.props.skipDeleteConfirm}
                    className={this.props.actionBarClassName}
                    searchQuery={this.props.searchQuery}
                    search={this._debouncedSearch}
                    enableSearch={this.props.enableSearch}
                    isBusy={this.props.disabled}
                    selection={this.props.selection}
                    deleteAction={ifPermission(this.props.user, deletePermission, this.props.deleteAction)}
                    buttonAction={
                        this.props.disableButtonAction
                            ? false
                            : ifPermission(
                                  this.props.user,
                                  this.props.buttonPermissions || PERMISSIONS[`${this.props.model.toUpperCase()}_ADD`],
                                  this._buttonAction
                              )
                    }
                    selectionActions={this.props.selectionActions}
                    selectionFunctions={this.props.selectionFunctions}
                    model={this.props.model}
                    buttonLabel={getText(this.props.model, 'tableButtonLabel')}
                />
                {AdvancedSearchForm ? (
                    <AdvancedSearchForm total={this.props.totalResults} updateFilter={this._updateFilter} />
                ) : null}
                <Table
                    maxHeight={this.props.maxHeight}
                    changeSort={this._changeSort}
                    sort={this.props.sort}
                    sortDirection={this.props.sortDirection}
                    enableRowFunction={this._allowRowInteraction}
                    enableSelectFunction={this._allowRowSelection}
                    canOpenRows={this.props.canOpenRows}
                    noSelect={
                        this.props.forceNoSelect ||
                        ifPermission(this.props.user, deletePermission, this.props.noSelect, true)
                    }
                    onSelect={ifPermission(this.props.user, deletePermission, this._select)}
                    selectAll={this._selectAll}
                    selectAllChecked={this._selectAllChecked().checked}
                    selectAllHalfChecked={this._selectAllChecked().halfChecked}
                    onOpen={this._open}
                    HeaderComponent={this.props.headerComponent}
                    RowComponent={this.props.rowComponent}
                    data={
                        this.props.filterFunction
                            ? this.props.filterFunction(this.props.data || this.props.tableData)
                            : this.props.data || this.props.tableData
                    }
                    headers={this.props.headers || HEADERS[this.props.model]}
                    highlightFunction={this.props.highlightFunction}
                    isSelected={this._isSelected}
                    loading={`${
                        this.props.fetching
                            ? getText(this.props.model, 'tableLoadingText')
                            : this.props.disabled
                              ? getText(this.props.model, 'tableDeletingText')
                              : ''
                    }`}
                    largeColumns={LARGE_COLUMNS[this.props.model] || []}
                    smallColumns={SMALL_COLUMNS[this.props.model] || []}
                    transformFunctions={this.props.transformFunctions}
                    pagination={this.props.pagination}
                    currentPage={this.props.currentPage}
                    resultsPerPage={this.props.resultsPerPage}
                    totalPages={this.props.totalPages}
                    paginationChange={this._fetch}
                    selectedRows={this.props.selection.length}
                    rowProps={this.props.rowProps}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, props) => ({
    user: currentUserSelector(state),
    tableData: selectors.dataSelector(state, props),
    fetching: selectors.isFetchingSelector(state, props),
    fetched: selectors.isFetchedSelector(state, props),
    selection: selectors.selectedSelector(state, props),
    selectionItems: selectors.selectedItemsSelector(state, props),
    disabled: selectors.isDisabledSelector(state, props),
    contextId: contextSubjectSelector(state, props),
    currentPage: selectors.currentPageSelector(state, props),
    resultsPerPage: selectors.resultsPerPageSelector(state, props),
    totalResults: selectors.totalResultsSelector(state, props),
    totalPages: selectors.totalPagesSelector(state, props),
    searchQuery: selectors.searchQuerySelector(state, props),
    sort: selectors.sortSelector(state, props),
    sortDirection: selectors.sortDirectionSelector(state, props),
    preferences: preferencesSelector(state, props)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({ changeSort, select, newAction, openAction, search, initTable, updateFilter }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AdminTable);
